import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmploymentTypes } from '@app/constants/employment-types';
import { TerminationCodes } from '@app/constants/termination-codes';
import { EmploymentTypeDisplayOptions } from '@app/types/translatables/employment-type-display.options';
import { BaseForm } from '@forms/base.form';
import { Office } from '@models/company/office.model';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'app-form-employees-create-terminated-job',
    templateUrl: './create-terminated-job.template.html',
})
export class CreateTerminatedJobForm extends BaseForm {
    @Input() employee: Employee;
    @Input() offices: Office[] = [];
    @Input() terminatedOn: string;
    @Output() terminatedOnChange = new EventEmitter();

    employmentTypes = EmploymentTypes;
    employmentTypeDisplayOptions = EmploymentTypeDisplayOptions;
    terminationCodes = TerminationCodes;

    setOffice(office: Office): void {
        this.employee.officeId = office.id;
        this.employee.office = office;
    }

    setTerminatedOn(date: string): void {
        this.terminatedOn = date;
        this.terminatedOnChange.emit(date);
    }
}
